import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
export const ServiceCard = ({ handleShow, data, handleEditModal, roleID }) => {
  const [showMore, setShowMore] = useState(false);
  const { refsdata } = useSelector((state) => state.refstypes);
  const {
    svc_id,
    svc_name,
    svc_cat_desc,
    svc_typ_desc,
    svc_desc,
    svc_cost_amt,
    svc_provider_local_cost_amt,
    svc_photo1,
  } = data;
  const shouldText = svc_desc.length > 100;
  const displayText = showMore
    ? svc_desc
    : `${svc_desc.slice(0, 100)}${shouldText ? "..." : ""}`;
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  const xchange_rate = refsdata.usr?.iso_currency_xchng || [];

  return (
    <div className="facility" style={{ paddingBottom: "10px" }}>
      <div className="flex justify-between border-b border-b-slate-300">
        <div className="flex gap-2">
          {svc_photo1 ? (
            <img
              src={svc_photo1}
              className="w-12 h-12 rounded-full"
              alt="service"
            />
          ) : (
            <Icon
              icon="streamline-emojis:hospital"
              style={{ fontSize: "40px" }}
            />
          )}

          <div>
            <h5 className="!text-base m-0 !text-main">{svc_name}</h5>
            <p className="!text-description !font-normal">
              #{svc_id} &nbsp;
              {displayText}
              {shouldText && (
                <span onClick={toggleShowMore}>
                  {" "}
                  {showMore ? "Show Less" : "Show More"}
                </span>
              )}
            </p>
          </div>
        </div>

        <div className="icons">
          {roleID === "3" || roleID === "5" ? (
            ""
          ) : (
            <>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
              >
                <Icon
                  onClick={() => handleEditModal(data)}
                  icon="fluent:edit-48-filled"
                  color="red"
                  className="cursor-pointer"
                />
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
              >
                <Icon
                  onClick={handleShow}
                  icon="mingcute:delete-fill"
                  color="red"
                  className="cursor-pointer"
                />
              </OverlayTrigger>
            </>
          )}
        </div>
      </div>

      <div className="h-full grid grid-cols-2 mt-3">
        <div className="w-full">
          <span className="text-sm text-main font-medium">
            Service Category
          </span>
          <h4 className="text-description !text-sm !font-medium">
            {svc_cat_desc}
          </h4>
        </div>
        <div className="w-full">
          <span className="text-sm text-main font-medium">Service Type</span>
          <h4 className="text-description !text-sm !font-medium">
            {svc_typ_desc}
          </h4>
        </div>
        <div className="w-full">
          <span className="text-sm text-main font-medium">Service Cost</span>
          <h4 className="text-description !text-sm !font-medium">
            {svc_cost_amt}
          </h4>
        </div>
        <div className="w-full">
          <span className="text-sm text-main font-medium">
            {xchange_rate[0]?.iso_curr_name}
          </span>
          <h4 className="text-description !text-sm !font-medium">
            {svc_provider_local_cost_amt}
          </h4>
        </div>
      </div>
    </div>
  );
};
